import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.touchHandler = (e) => this.createRipple(e)
    this.element.addEventListener("touchstart", this.touchHandler, { passive: true })
  }

  disconnect() {
    this.element.removeEventListener("touchstart", this.touchHandler)
  }

  click(event) {
    this.createRipple(event)
  }

  createRipple(event) {
    const rect = this.element.getBoundingClientRect()
    const x = event.touches ? event.touches[0].clientX : event.clientX
    const y = event.touches ? event.touches[0].clientY : event.clientY
    const circle = document.createElement("span")
    circle.classList.add("ripple-circle")
    circle.style.left = `${x - rect.left - 10}px`
    circle.style.top = `${y - rect.top - 10}px`
    this.element.style.position = "relative"
    this.element.style.overflow = "hidden"
    this.element.appendChild(circle)
    circle.addEventListener("animationend", () => circle.remove())
  }
}
